import { Base } from "ui/Scripts/source/framework/base";
import { IListItems, ListItems } from "ui/Scripts/source/framework/listItems";
import { ModulePartnerListItem, IModulePartnerListItem } from "./modulePartnerListItem";

export interface IModulePartnerListItems extends IListItems<IModulePartnerListItem> {
    defaultUnitId: string;
}

export class ModulePartnerListItems extends ListItems<ModulePartnerListItem> implements IModulePartnerListItems {
    defaultUnitId: string;

    constructor();
    constructor(obj: IModulePartnerListItems);
    constructor(obj?: any) {
        super(obj);
        this.defaultUnitId = obj && obj.defaultUnitId || "";
        this.items = Base.getTypedArray(obj ? obj.items : null, ModulePartnerListItem);
    }
}